import { computed, onMounted, onUnmounted, ref } from "vue";

export const useBreakpoints = () => {
  let windowWidth = ref(window.innerWidth);

  const onWidthChange = () => (windowWidth.value = window.innerWidth);
  onMounted(() => window.addEventListener("resize", onWidthChange));
  onUnmounted(() => window.removeEventListener("resize", onWidthChange));

  const type = computed(() => {
    if (windowWidth.value < 479) return "xs";
    if (windowWidth.value >= 479 && windowWidth.value < 1200) return "md";
    else return "lg"; // Fires when windowWidth.value >= 1200
  });

  const width = computed(() => windowWidth.value);
  const isMobile = computed(() => {
    return windowWidth.value < 768;
  });
  const isTablet = computed(() => {
    return windowWidth.value < 991;
  });

  const isLargeTablet = computed(() => {
    return windowWidth.value < 1024.98;
  });

  const isDesktop = computed(() => {
    return windowWidth.value >= 992;
  });

  return { width, type, isMobile, isTablet, isLargeTablet, isDesktop };
};
